import { render, staticRenderFns } from "./PaymentStatus.vue?vue&type=template&id=05ee3cba&scoped=true&"
import script from "./PaymentStatus.vue?vue&type=script&lang=ts&"
export * from "./PaymentStatus.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentStatus.vue?vue&type=style&index=0&id=05ee3cba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ee3cba",
  null
  
)

export default component.exports